<template>
  <div
    class="modal fade"
    :id="modalId"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content m-t100">
        <div class="modal-header">
          <h4 class="modal-title" id="myModalLabel">Confirmation</h4>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click="resetValidations($v)"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form class="content-form">
            <div class="form-group">
              <div v-if="actionType === 'SHORTLIST'">
                <div class="row">
                  <div class="col-12 mb-2 pr-2">
                    <label class="control-label"
                      >Profile
                      <span class="text-danger">*</span>
                    </label>
                    <select
                      name="jobProfile"
                      class="form-control"
                      :class="{ invalid: errors.first('jobProfile') }"
                      v-validate="'required'"
                      v-model="offerData.jobId"
                    >
                      <option
                        v-for="jobProfile in jobProfiles"
                        :key="jobProfile.id"
                        :value="jobProfile.id"
                      >
                        {{ jobProfile.job_name }}
                      </option>
                    </select>
                    <span
                      v-if="errors.first('jobProfile')"
                      class="valid-feedback alert-danger"
                      >{{ errors.first("jobProfile") }}
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-2 pr-2">
                    <label class="control-label"
                      >Designation
                      <span class="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="designation"
                      placeholder="Enter Designation"
                      v-validate="'required|alpha_spaces|min:2|max:100'"
                      data-vv-validate-on="blur|input"
                      :class="{ invalid: errors.first('designation') }"
                      class="form-control"
                      v-model="offerData.designation_offered"
                    />
                    <span
                      v-if="errors.first('designation')"
                      class="valid-feedback alert-danger"
                      >{{ errors.first("designation") }}</span
                    >
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-2 pr-2">
                    <label class="control-label"
                      >Package
                      <span class="text-danger">*</span>
                    </label>
                    <div class="input-group">
                      <input
                        type="text"
                        name="package"
                        placeholder="e.g. 5.00 (In Lacs)"
                        v-validate="'required|decimal:2'"
                        data-vv-validate-on="blur|input"
                        :class="{ invalid: errors.first('package') }"
                        class="form-control"
                        v-model="offerData.package_offered"
                      />
                      <div class="input-group-append">
                        <span class="input-group-text"> LPA </span>
                      </div>
                    </div>
                    <span
                      v-if="errors.first('package')"
                      class="valid-feedback alert-danger"
                      >{{ errors.first("package") }}
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-2 pr-2">
                    <label class="control-label">Expected Joining </label>
                    <div class="input-group mb-3">
                      <date-picker
                        id="expectedJoining"
                        :class="{
                          'invalid-border': errors.first('expectedJoining'),
                        }"
                        name="expectedJoining"
                        v-model="offerData.expected_joining"
                        placeholder="Select Date"
                        :config="config"
                        :minDate="new Date()"
                        @dp-hide="validateExpectedJoining"
                      >
                      </date-picker>
                      <div class="input-group-append">
                        <span
                          class="input-group-text"
                          id="basic-addon2"
                          @click="toggleDatePicker"
                        >
                          <i class="fa fa-calendar" aria-hidden="false"> </i>
                        </span>
                        <span
                          v-if="errors.first('expectedJoining')"
                          class="valid-feedback alert-danger"
                          style="top: -14px !important; margin-right: 35px"
                          >{{ errors.first("expectedJoining") }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 mb-2 pr-2 position-relative">
                  <label class="control-label"
                    >Comments
                    <span class="text-danger">*</span>
                  </label>
                  <common-rich-text-box
                    :width="'100%'"
                    modalId="update-application-status-summernote"
                    @onKeyUp="onKeyUp"
                    @onBlur="onBlur"
                  />
                  <span
                    class="valid-feedback alert-danger"
                    v-if="isCommentsTouched && !isCommentValid"
                  >
                    Comments are required
                  </span>
                  <span
                    class="valid-feedback alert-danger"
                    v-if="!isCommentLengthValid"
                  >
                    Comments must not exceed 5000 characters
                  </span>
                </div>
              </div>
              <div class="row">
                <div class="col-12 mt-3">
                  <p>
                    {{ actionMessage }}
                  </p>
                </div>
              </div>
              <div class="row">
                <label class="col-sm-3"><b>To be Mailed :-</b></label>
                <label
                  class="checkbox-inline px-3"
                  v-if="applicationData.belongsToCampusRecruitement"
                >
                  <input
                    type="checkbox"
                    value="Coordinator"
                    v-model="isCoordinator"
                  />
                  Coordinator
                </label>
                <label class="checkbox-inline">
                  <input type="checkbox" value="Students" v-model="isStudent" />
                  Applicant
                </label>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer text-center">
          <button
            type="button"
            class="btn btn-dark"
            @click="resetValidations($v)"
            data-dismiss="modal"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-cp ml-2"
            @click="handleSubmit"
            :disabled="submitDisable"
          >
            {{
              actionType?.charAt(0)?.toUpperCase() +
              actionType?.toLowerCase()?.slice(1)
            }}
            {{ isCoordinator || isStudent ? "and Mail" : "" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import CommonRichTextBox from "../../Common/_components/common-rich-text-box.vue";
import datePicker from "vue-bootstrap-datetimepicker";
import moment from "moment";

export default {
  components: {
    CommonRichTextBox,
    datePicker,
  },
  props: {
    actionType: {
      type: String,
    },
    modalId: {
      type: String,
      required: true,
    },
    applicationData: {
      type: Object,
    },
    jobProfiles: {
      type: Array,
    },
  },
  data() {
    return {
      isCommentsTouched: false,
      isCommentValid: true,
      isCoordinator: false,
      isStudent: false,
      offerData: {},
      config: {
        format: "YYYY/MM/DD",
        useCurrent: false,
        showClear: true,
        showClose: true,
        sideBySide: true,
      },
    };
  },
  methods: {
    handleSubmit(e) {
      this.$validator.validateAll().then(() => {
        if (
          this.$validator.errors.items.length === 0 &&
          this.isCommentsValid() &&
          this.isCommentLengthValid
        ) {
          this.notifyParent(e);
          $("#UpdateApplicationStatusAppInfo").modal("hide");
        }
      });
    },
    /**
     *
     * @returns {Boolean} validated result
     * @description checks whether comments are valid or not
     */
    isCommentsValid() {
      return (
        this.offerData.comments &&
        this.offerData.comments !== "<p><br></p>" &&
        this.offerData.comments !== ""
      );
    },
    /**
     * @memberof module:ApplicanProfile.compoenents.update_application_status_modal
     * @description Notify parent with data when action confirmed
     */
    notifyParent() {
      this.offerData = {
        ...this.offerData,
        isStudent: this.isStudent,
        isCoordinator: this.isCoordinator,
      };
      this.$emit("onConfirmUpdateApplicationStatus", this.offerData);
    },
    /**
     * @memberof
     * @param {Object} v validation object
     * @description method - reset data validation
     */
    resetValidations(v) {
      v.$reset();
      this.isCommentsTouched = false;
      this.isCommentValid = false;
      $("#update-application-status-summernote").summernote("code", "");
    },
    /**
     * @memberof module:ApplicanProfile.compoenents.update_application_status_modal
     * @description set values of comments
     */
    onKeyUp(value) {
      this.offerData.comments = value;
      this.isCommentValid = this.isCommentsValid();
    },
    /**
     * @memberof module:ApplicanProfile.compoenents.update_application_status_modal
     * @description set values of comments
     */
    onBlur(value) {
      this.offerData.comments = value;
      this.isCommentsTouched = true;
      this.isCommentValid = this.isCommentsValid();
    },
    toggleDatePicker() {
      $("#expectedJoining").data("DateTimePicker").toggle();
    },
    validateExpectedJoining() {
      const currentDate = moment();
      const formattedDate = currentDate.format("DD MMMM YYYY");

      if (
        !this.offerData.expected_joining ||
        moment(this.offerData.expected_joining) < currentDate
      ) {
        this.$validator.errors.add({
          field: "expectedJoining",
          msg: `Date of Joining must be after ${formattedDate}`,
        });
      } else {
        this.$validator.errors.remove("expectedJoining");
      }
    },
  },
  computed: {
    /**
     * @memberof module:ApplicanProfile.compoenents.update_application_status_modal
     * @description Set action confirmation message
     */
    actionMessage() {
      let message;
      switch (this.actionType) {
        case "PROCESS":
          message = "Do you want to confirm process the applicant?";
          break;
        case "SHORTLIST":
          message = "Do you want to confirm shortlist the applicant?";
          break;
        case "DIFFER":
          message = "Do you want to confirm differ the applicant(s)?";
          break;
        case "HOLD":
          message = "Do you want to confirm to put on hold the applicant?";
          break;
        case "NOT APPEARED":
          message = "Do you want to confirm that applicant is not appeared?";
          break;
        case "TALENT POOL":
          message = "Do you want to confirm to move applicant to talent pool?";
          break;
        case "JOINED":
          message = "Do you want to confirm that applicant(s) is joined?";
          break;
        default:
          break;
      }
      return message;
    },

    submitDisable() {
      if (this.actionType === "SHORTLIST") {
        return !this.isCommentValid || !this.offerData;
      } else {
        return !this.isCommentValid;
      }
    },

    /**
     * @memberof module:ApplicanProfile.compoenents.update_application_status_modal
     * @description checks length for the review
     */

    isCommentLengthValid() {
      return !this.offerData.comments || this.offerData.comments.length <= 5000;
    },
  },
  validations() {
    const comments = {
      required,
    };

    return {
      comments,
    };
  },
  watch: {
    /**
     * @memberof module:ApplicanProfile.compoenents.update_application_status_modal
     * @description sets already added comments in the box
     */
    applicationData(value) {
      this.offerData.comments = value.application_comments;
      this.offerData.designation_offered = value.designation_offered;
      this.offerData.package_offered = value.package_offered;
      this.offerData.expected_joining = value.expected_joining;
      this.offerData.jobId = value.jobId;
      this.isCommentValid = this.isCommentsValid();
      $("#update-application-status-summernote").summernote(
        "code",
        this.offerData.comments
      );
    },
  },
  beforeDestroy() {
    if (this.modalId) {
      $(`#${this.modalId}`).modal("hide");
      $(".modal-backdrop").hide();
      $("body").removeClass("modal-open");
    }
  },
  mounted() {
    $(`#${this.modalId}`).on("hidden.bs.modal", () => {
      this.resetValidations(this.$v);
    });
    this.offerData.comments = this.applicationData.application_comments;
    this.isCommentValid = this.isCommentsValid();
  },
};
</script>

<style lang="css" scoped>
.control-label {
  display: inline-flex;
}
</style>
